
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: 'courier-status',
    props: {
        status: {
            type: Object as PropType<{ id: number; title: string; }>,
            default: null
        }
    }
})
